import { call, createAction, safe, select, takeLeading } from "starfx";

import { ThunkCtx } from "@app/types";

import { schema } from "../schema";
import { xThunk } from "../xapis";

import type { ApiCtx } from "starfx";
import type { Next } from "starfx";
import type { TUIInvoiceEditing } from "@app/statefx/schema/uiInvoiceEditing.def";

export const setIETreeState = xThunk.create<Partial<TUIInvoiceEditing>>(
  `uiIEditing/setIETreeState`,
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    const state = yield* select(schema.uiInvoiceEditing.select);
    const newState = { ...state, ...ctx.payload };
    yield* schema.update(schema.uiInvoiceEditing.set(newState));
    yield* next();
  }
);
